import { LifeBuoy, Mail, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePortalPatientData } from './portalContext';
import { Panel, PortalPage } from './ui';

export default function SupportPage() {
  const { t } = useTranslation();
  const { profile, activeContext } = usePortalPatientData();

  return (
    <PortalPage title={t('support.title')} description={t('support.description')}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Panel title={t('support.portalSupport')}>
          <div className="space-y-2 text-sm">
            <p className="flex items-center gap-2 text-slate-700">
              <Mail size={16} /> {t('support.portalSupportLine')}
            </p>
            <p className="text-slate-500">{t('support.portalSupportBody')}</p>
          </div>
        </Panel>
        <Panel title={t('support.billingSupport')}>
          <div className="space-y-2 text-sm">
            <p className="flex items-center gap-2 text-slate-700">
              <Phone size={16} /> {profile?.provider?.name || activeContext?.provider?.name || t('support.yourCareTeam')}
            </p>
            <p className="text-slate-500">{t('support.billingSupportBody')}</p>
          </div>
        </Panel>
        <Panel title={t('support.urgentCare')}>
          <div className="space-y-2 text-sm">
            <p className="flex items-center gap-2 text-slate-700">
              <LifeBuoy size={16} /> {t('support.urgentCareLine')}
            </p>
            <p className="text-slate-500">{t('support.urgentCareBody')}</p>
          </div>
        </Panel>
      </div>
    </PortalPage>
  );
}
